import tu1 from "../assets/img/tu2.jpg";
import zq from "../assets/img/zq2.jpg";
import gw from "../assets/img/gw2.jpg";
import gxw from "../assets/img/gxw2.jpg";
import sxw from "../assets/img/sxw2.jpg";
import jcb from "../assets/img/jcb2.jpg";
import lyy from "../assets/img/lyy2.jpg";
import lzm from "../assets/img/lzm2.jpg";
import wr from "../assets/img/wr2.jpg";
import sdf from "../assets/img/sdf2.jpg";
import lj from "../assets/img/lj2.jpg";

const dataList = [
  {
    id: "001",
    img: tu1,
    title: "预告：一支党校青年团，带你探究十年的十个“为什么”",
    link: "http://www.xinhuanet.com/sikepro/20221006/9a1ecc0cab5a49808494bd40fdf7b6a0/c.html",
    src: "https://vodpub6.v.news.cn/yqfbzx-original/20221006/202210069a1ecc0cab5a49808494bd40fdf7b6a0_701107764a974bfc8ba5f209cff1b039.mp4",
  },
  {
    id: "002",
    img: zq,
    title: "以“理”服人｜为什么要走好新时代的“赶考路”？",
    link: "http://www.xinhuanet.com/sikepro/20221006/2a66d39179a54e28b40b3dd95cef2f90/c.html",
    src1: "https://vodpub6.v.news.cn/yqfbzx-original/20221006/202210062a66d39179a54e28b40b3dd95cef2f90_8db1912411004d6482205e116291473d.mp4",
    src: "https://vodpub1.v.news.cn/original/20220930/c60923109eb7411080d9f8053075c8d7.mp4",
  },
  {
    id: "003",
    img: gw,
    title: "以“理”服人｜为什么要推进经济高质量发展？",
    link: "http://www.xinhuanet.com/sikepro/20221006/7889ef64dd274cb6826f2afcc4cf7511/c.html",
    src1: "https://vodpub6.v.news.cn/yqfbzx-original/20221006/202210067889ef64dd274cb6826f2afcc4cf7511_7f492873f7a843c58d67adbe73dd261f.mp4",
    src: "https://vodpub1.v.news.cn/original/20220930/deaa42f0604346c0a6bc90b996e7ecd3.mp4",
  },
  {
    id: "004",
    img: gxw,
    title: "以“理”服人｜为什么要将全面深化改革进行到底？",
    link: "http://www.xinhuanet.com/sikepro/20221007/466999def69f44138476fa9cc4b0d6bb/c.html",
    src1: "https://vodpub6.v.news.cn/yqfbzx-original/20221007/20221007466999def69f44138476fa9cc4b0d6bb_a32caa8e1a7a47a9a550d0656f5f1156.mp4",
    src: "https://vodpub1.v.news.cn/original/20220930/2e19060b2e7541528d591999b56791a3.mp4",
  },
  {
    id: "005",
    img: sxw,
    title: "以“理”服人｜为什么说全过程人民民主是全链条、全方位、全覆盖的民主？",
    link: "http://www.news.cn/sikepro/20221007/d77c5827a5374867be199cc0cba6a7cb/c.html",
    src1: "https://vodpub6.v.news.cn/yqfbzx-original/20221007/20221007ccb43c1098b24c729dd977f81f61339c_9bc80bbd028a40e0b3416ad31a2dbe30.mp4",
    src: "https://vodpub1.v.news.cn/original/20220930/f82391cf84f14dc490fc3e71dae21950.mp4",
  },
  {
    id: "006",
    img: jcb,
    title: "以“理”服人｜为什么说公平正义是法治的生命线？",
    link: "http://www.xinhuanet.com/sikepro/20221008/e99c4a6b172545ffb39070eceb760919/c.html",
    src1: "https://vodpub6.v.news.cn/yqfbzx-original/20221008/20221008e99c4a6b172545ffb39070eceb760919_3ba9296c841947189db3efc5faa074e9.mp4",
    src: "https://vodpub1.v.news.cn/original/20220930/05b225d8c1584bf59ad6d82324fde121.mp4",
  },
  {
    id: "007",
    img: lyy,
    title: "以“理”服人｜为什么我们最有理由说“文化自信”？",
    link: "http://www.xinhuanet.com/sikepro/20221008/d5b9675ee228459b9cd5b6ca1cb41cf0/c.html",
    src1: "https://vodpub6.v.news.cn/yqfbzx-original/20221008/20221008d5b9675ee228459b9cd5b6ca1cb41cf0_0ce3f24585904186954f34ecfac87ab6.mp4",
    src: "https://vodpub1.v.news.cn/original/20220930/a2f8ae34a6b148df8cda2b9c2f2f22ad.mp4",
  },
  {
    id: "008",
    img: lzm,
    title: "以“理”服人｜为什么说让老百姓过上好日子是一切工作的出发点和落脚点？",
    link: "http://www.xinhuanet.com/sikepro/20221009/de19475385974838a938f15dc63ccd02/c.html",
    src1: "https://vodpub6.v.news.cn/yqfbzx-original/20221009/20221009de19475385974838a938f15dc63ccd02_e192881ea921407fbb277126372413a6.mp4",
    src: "https://vodpub1.v.news.cn/original/20220930/cde65009b213445b823c2246c342c928.mp4",
  },
  {
    id: "009",
    img: wr,
    title: "以“理”服人｜为什么“绿水青山就是金山银山”？",
    link: "http://www.xinhuanet.com/sikepro/20221009/fcb96fe2d7454c19ab0fcccf0547ec65/c.html",
    src1: "https://vodpub6.v.news.cn/yqfbzx-original/20221009/20221009e250ca267aa84d66970cc27235f1ff43_a73fa998965947d58e01d08475426df7.mp4",
    src: "https://vodpub1.v.news.cn/original/20220930/bf65933e531e482ea9a60df1ddb51fa9.mp4",
  },
  {
    id: "010",
    img: sdf,
    title: "以“理”服人｜为什么要抓好维护国家安全这一“头等大事”？",
    link: "http://www.xinhuanet.com/sikepro/20221010/b50ee0da3b57450fa14553c8288b934e/c.html",
    src1: "https://vodpub6.v.news.cn/yqfbzx-original/20221010/52ac0d0e4ab946bb89eeecdd3f3ff02a.mp4",
    src: "https://vodpub1.v.news.cn/original/20220930/8d36fb7469924a65b0185d61ea7487f4.mp4",
  },
  {
    id: "011",
    img: lj,
    title: "以“理”服人｜为什么说构建人类命运共同体才是人间正道？",
    link: "http://www.xinhuanet.com/sikepro/20221010/89ca7d6286e646d697a9aa600a073e2e/c.html",
    src1: "https://vodpub6.v.news.cn/yqfbzx-original/20221010/2022101089ca7d6286e646d697a9aa600a073e2e_843b29479235407fbcfcfa0cde5eccea.mp4",
    src: "https://vodpub1.v.news.cn/original/20220930/3770ef6db85b42248aebb393ab7937db.mp4",
  },
];

export default dataList;
